<template>
  <!-- 商品列表 -->
  <div class="productList">
    <div ref="header">
      <!-- 面包屑导航 -->
      <crumbs-bar
        @refresh="handleRefresh"
        :crumbsList="['商品管理', $route.meta.title]"
      >
        <template slot="controls">
          <el-button
            type="warning"
            @click="handleAdd()"
            style="margin-right: 10px"
            v-if="buttonVisibility.add"
          >
            添加商品
          </el-button>
          <el-dropdown style="margin-right: 10px" @command="dropdownPL">
            <el-button type="primary" v-if="buttonVisibility.batch">
              批量上下架<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="2">批量上架</el-dropdown-item>
              <el-dropdown-item :command="1">批量下架</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link
            @click="explain = true"
            style="margin-right: 10px"
            icon="el-icon-question"
            :underline="false"
            type="warning"
            >操作说明</el-link
          >
          <el-dropdown style="margin-right: 10px" @command="dropdownCommand">
            <el-button type="primary" v-if="buttonVisibility.upload">
              批量上传详情图<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="0">按条形码上传</el-dropdown-item>
              <el-dropdown-item :command="1"
                >按ERP商品内码上传</el-dropdown-item
              >
              <el-dropdown-item :command="2"
                >按ERP商品编号上传</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" icon="el-icon-download"    
            @click="exportData"
            v-if="buttonVisibility.export"
            >导出数据</el-button
          >
          <!-- <upload text="商品分类" @fileChange="goodsClass" style="margin-right: 10px"></upload> -->
          <el-button
            type="danger"
            icon="el-icon-download"
            :disabled="selectedList.length == 0"
            @click="handlePut(1)"
            v-if="buttonVisibility.xiaJia"
            >批量下架
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            :disabled="selectedList.length == 0"
            @click="handlePut(2)"
            v-if="buttonVisibility.shangJia"
            >批量上架
          </el-button>
          <!-- 价格等级现在没有使用 -->
          <el-button
            type="primary"
            icon="el-icon-s-open"
            @click="priceLevel"
            v-if="buttonVisibility.priceLevel"
            >价格等级</el-button
          >
        </template>
      </crumbs-bar>
      <!-- 搜索框 -->
      <search-bar>
        <template>
          <div class="searchBarLefy">
            <div class="searchBar-Lefy">
              <el-date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                clearable
                v-model="searchForm.startdate"
                style="width: 150px; margin-right: 10px"
                placeholder="选择开始日期"
              >
              </el-date-picker>
              <el-date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                clearable
                v-model="searchForm.enddate"
                style="width: 150px; margin-right: 10px"
                placeholder="选择结束日期"
              >
              </el-date-picker>
              <!-- 洛奥活动状态字段修改为库存预警 -->
              <label class="label">库存预警：</label>
              <el-input
                v-model="searchForm.activityStatus"
                type="number"
                style="width: 150px; margin-right: 10px"
                clearable
                placeholder="输入预警值"
              >
              </el-input>

              <label class="label">分类：</label>
              <el-select
                v-model="searchForm.classify"
                placeholder="商品分类"
                style="width: 100px; margin-right: 10px"
                clearable
              >
                <el-option label="全部分类" value="0"></el-option>
                <el-option
                  v-for="(item, index) in classifyList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  style="white-space: pre"
                >
                </el-option>
              </el-select>
              <label class="label">楼层：</label>
              <el-select
                v-model="searchForm.attr"
                placeholder="商品楼层"
                style="width: 100px; margin-right: 10px"
                clearable
              >
                <el-option label="全部" value="0"></el-option>
                <el-option
                  v-for="(item, index) in attrList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <label class="label">商品状态：</label>
              <el-select
                v-model="searchForm.status"
                placeholder="商品状态"
                style="width: 100px; margin-right: 10px"
                clearable
              >
                <el-option label="全部" value="9"></el-option>
                <el-option label="已启用" value="2"></el-option>
                <el-option label="未启用" value="1"></el-option>
              </el-select>
            </div>
            <div class="searchBar-Right">
              <label class="label">库存状态：</label>
              <el-select
                v-model="searchForm.stock"
                placeholder="库存状态"
                style="width: 100px; margin-right: 10px"
                clearable
              >
                <el-option label="全部" value="99"></el-option>
                <el-option label="有库存" value="1"></el-option>
                <el-option label="无库存" value="0"></el-option>
              </el-select>
              <label class="label">商品图片：</label>
              <el-select
                v-model="searchForm.pic"
                placeholder="商品图片"
                style="width: 100px; margin-right: 10px"
                clearable
              >
                <el-option label="全部" value="99"></el-option>
                <el-option label="有图片" value="Y"></el-option>
                <el-option label="无图片" value="N"></el-option>
              </el-select>

              <p>
                <span class="labeljs">检索：</span>
                <el-input
                  v-model="searchForm.name"
                  style="width: 150px; margin-right: 10px"
                  clearable
                  placeholder="输入编号/名称"
                >
                </el-input>
              </p>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getTableData(1)"
                v-if="buttonVisibility.search"
                >搜索</el-button
              >
            </div>
          </div>
        </template>
      </search-bar>
    </div>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      ref="table"
      border
      :height="height"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="code"
        show-overflow-tooltip
        label="商品信息"
      >
        <template slot-scope="scope">
          <div class="scopeName">{{ scope.row.name }}</div>
          <!-- <div>商品ID:{{ scope.row.id }}</div> -->
          <div class="scopeName">商品编号(ERP):{{ scope.row.code }}</div>
          <div class="scopeName">ERP内码:{{ scope.row.goods_no }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="code"
        show-overflow-tooltip
        label="商品信息"
      >
        <template slot-scope="scope">
          <div class="scopeName">{{ scope.row.producer }}</div>
          <div class="scopeName">{{ scope.row.specification }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="code"
        show-overflow-tooltip
        label="商品图片"
      >
        <template slot-scope="scope">
          <div>
            <img-view :imgList="[{ url: scope.row.img_url, id: 0 }]"></img-view>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="code"
        show-overflow-tooltip
        label="库存"
      >
        <template slot-scope="scope">
          <div class="scopeName">库存:{{ scope.row.repertory }}</div>
          <div class="scopeName">效期时间:{{ scope.row.validTime }}</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="retailPrice"
        width="150"
        label="建议零售价"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        prop="retailPrice"
        width="150"
        label="AutRemark"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->

      <!-- <el-table-column
        align="center"
        width="150"
        prop="code"
        show-overflow-tooltip
        label="商品编号(ERP)"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="name"
        align="center"
        width="160"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column> -->
      <!-- 王航说不要了，没什么用 -->
      <!-- <el-table-column prop="entname" align="center" show-overflow-tooltip label="机构名称">
      </el-table-column> -->
      <!-- <el-table-column
        prop="goods_no"
        align="center"
        width="160"
        show-overflow-tooltip
        label="ERP内码"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="specification"
        label="商品规格"
        width="120"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="packingNnit"
        label="包装单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="producer"
        label="生产厂家"
        width="120"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="classify"
        label="商品分类"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="repertory"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="retailPrice"
        width="150"
        label="建议零售价"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="validTime"
        label="效期时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="商品ID"
      >
      </el-table-column> -->
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatType">{{
            scope.row.status | formatStatus
          }}</el-tag>
          <div v-if="scope.row.AutRemark">
            审核意见:{{ scope.row.AutRemark }}
          </div>
          <div v-if="scope.row.DisableTime && scope.row.status == '2'">
            时间:{{ scope.row.DisableTime }}
          </div>
          <div v-if="scope.row.EnableTime && scope.row.status !== '2'">
            时间:{{ scope.row.EnableTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            v-if="buttonVisibility.edit"
            >编辑</el-button
          >
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            v-if="scope.row.status == 1 && buttonVisibility.enable"
            >启用</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            v-else-if="scope.row.status !== 2 && buttonVisibility.disable"
            >禁用
          </el-button>
          <!-- <el-button type="primary" style="padding:2px 3px;" plain
            @click="controlGoods(scope.row)">控销</el-button> -->
          <!-- <el-button type="primary" style="padding:2px 3px;" plain
            @click="areaPrice(scope.row)">区域价格</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div ref="bottom">
      <pagination
        :allPage="allPage"
        :pageSize="pageSize"
        :currIndex="currPage"
        @hanSiChange="hanSiChange"
        @hanCurrChange="hanCurrChange"
      ></pagination>
    </div>
    <upload
      ref="upload"
      style="display: none"
      @fileChange="uploadGoods"
      accept="image/jpg,image/jpeg,image/png"
      :multiple="true"
    ></upload>
    <upload
      ref="uploadEXecl"
      style="display: none"
      @fileChange="uploadEXecl"
      :multiple="true"
    ></upload>
    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面显示的为从ERP同步过来的基础商品数据</p>
        <p>
          编辑：可调整商品封面图、详情图、说明书、绑定商品分类、商品标签等信息（灰色输入框代表不可编辑）
        </p>
        <p>禁用：禁用后商品将不会在商城中显示</p>
        <!-- <p>价格等级：可设置多个价格等级，添加价格等级后，需要在商品编辑界面中设置价格，<span style="font-weight:bold;">客户列表</span>界面绑定后生效</p> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";
import { mapState } from 'vuex';

export default {
  name: "productList",
  mixins: [formatStatus],
  data() {
    return {
      entId: "",
      /**表格数据 */
      // {
      //   id:"商品id",
      //   code:"商品编号",
      //   name:"商品名称",
      //   entid:"机构ID",
      //   entname:"机构名称",
      //   specification:"商品规格",
      //   packingNnit:"包装单位",
      //   producer:"生产厂家",
      //   classify:"商品分类",
      //   repertory:"库存",
      //   retailPrice:"建议零售价",
      //   validTime:"效期时间",
      //   status:"状态",
      //   sort:"排序"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      // 商品分类 商品属性 商品状态 库存状态 商品图片 活动专区 活动状态 商品名称
      searchForm: {
        classify: "",
        attr: "",
        status: "9",
        stock: "",
        pic: "",
        activityArea: "",
        activityStatus: "",
        name: "",
        startdate: "",
        enddate: "",
      },
      /**select选中项 */
      selectedList: [],
      /**搜索下拉数据 */
      attrList: [], //商品属性列表
      classifyList: [], //商品分类别表

      /**上传详情图 */
      imgType: 1, //上传图片的类型

      /**使用说明 */
      explain: false,
      height: 0,
      EXeType: 0,
    };
  },
  computed: {
    ...mapState(['buttonPermissions']),
    // 按钮权限
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['商品列表'] || [] ;
      // console.log('商品buttonsLimit', buttonsLimit);
      return {
        add: buttonsLimit.includes('添加商品'),
        batch: buttonsLimit.includes('批量上下架'),
        upload: buttonsLimit.includes('批量上传详情图'),
        export: buttonsLimit.includes('导出数据'),
        xiaJia: buttonsLimit.includes('批量下架'),
        shangJia: buttonsLimit.includes('批量上架'),
        priceLevel: buttonsLimit.includes('价格等级'),
        search: buttonsLimit.includes('搜索'),
        edit: buttonsLimit.includes('编辑'),
        enable: buttonsLimit.includes('启用'),
        disable: buttonsLimit.includes('禁用')
      }
    }
  },
  mounted() {
    this.entId = localStorage.getItem("entId");
    // this.searchForm.startdate = this.$theMonthFirstDay(); // 默认查询本月的，查询太多了会卡
    // this.searchForm.enddate = this.$theMonthFirstOnDay();
    this.getTableData();
    this.getClassifyList();
  },
  activated() {
    this.height =
      document.documentElement.clientHeight -
      this.$refs.header.clientHeight -
      this.$refs.bottom.clientHeight -
      50;
  },
  methods: {
    /**批量上传图片 */
    /**dropdownCommand回调，记录上传图片的类型 */
    dropdownCommand(val) {
      this.imgType = val;
      this.$confirm("最多可选择200张", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.upload.handleClick();
      });
    },
    // 批量上下架
    dropdownPL(val) {
      let msg = "";
      if (val == 2) {
        msg = "上架";
      } else {
        msg = "下架";
      }
      this.EXeType = val;
      console.log(val);
      this.$confirm("确定要批量" + msg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.uploadEXecl.handleClick();
      });
    },
    // 商品批量上下架
    uploadEXecl(file) {
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("FileNmaes", file[i]);
        }
        this.$uploadRequest({
          url:
            "/Management/GoodsAdmin/AutGoodsStatusToExcel?status=" +
            this.EXeType,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            console.log(res);
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "success",
              });
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    // 商品详情图片上传回调
    uploadGoods(file) {
      file = file.slice(0, 200); //最多可选择200张，多余的将会截断
      if (file.length) {
        let type = ["TM", "SP", "SPCode"];
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("FileNmaes", file[i]);
        }
        this.$uploadRequest({
          url:
            "Management/GoodsAdmin/SaveGoodsImgToList?entId=" +
            this.entId +
            "&drType=" +
            type[this.imgType],
          method: "post",
          data: fileData,
        })
          .then((res) => {
            console.log(res);
            if (res.flag == 0) {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },

    updata() {
      this.getTableData();
      this.getClassifyList();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GoodsList",
        category: this.searchForm.classify || "0",
        attribute: this.searchForm.attr || "0",
        status: this.searchForm.status || "9",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        startdate: this.searchForm.startdate,
        enddate: this.searchForm.enddate,
        promtype:
          this.searchForm.activityArea == "99"
            ? ""
            : this.searchForm.activityArea,
        // promstatus: this.searchForm.activityStatus || "99",
        stock_quantity: this.searchForm.activityStatus,
        goodsPic: this.searchForm.pic || "99",
        spStatus: this.searchForm.stock || "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage = res.recordCount;
          this.tableData = [];
          this.height =
            document.documentElement.clientHeight -
            this.$refs.header.clientHeight -
            this.$refs.bottom.clientHeight -
            50;
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.tableData.push({
                id: res.data[i].article_id,
                code: res.data[i].goodscode,
                name: res.data[i].sub_title,
                entname: res.data[i].entname,
                entid: res.data[i].entId,
                specification: res.data[i].drug_spec,
                packingNnit: res.data[i].package_unit,
                producer: res.data[i].drug_factory,
                classify: res.data[i].category,
                repertory: res.data[i].stock_quantity,
                retailPrice: res.data[i].price,
                validTime: res.data[i].valdate,
                articleId: res.data[i].article_id,
                organId: res.data[i].adminentid,
                status: res.data[i].status,
                sort: res.data[i].sort_id,
                goods_no: res.data[i].goods_no,
                img_url: this.$setImgUrl(res.data[i].img_url),
                AutRemark: res.data[i].AutRemark,
                DisableTime: res.data[i].DisableTime,
                EnableTime: res.data[i].EnableTime,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**获取检索条件数据 */
    //获取分类和属性
    getClassifyList() {
      let data = {
        type: "GoodsAttributeBox",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "LoadCheckBox";
      this.$requestSys({
        url:
          "goods/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.attrList = this.changeArr(res.attributeList);
            this.classifyList = this.changeArr(res.categoryList);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //数组转化
    changeArr(list) {
      list = list.split("</option><option");
      list = list.map((item) => {
        let label = item
          .split("'>")[1]
          .split("</option>")[0]
          .replace(/&nbsp;/g, " ");
        let value = item.split("value='")[1].split("'>")[0];
        return { label, value };
      });
      return list;
    },

    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**批量上架 */
    handlePut(status) {
      //将selected选中的list转化为字符串
      let idList = [];
      this.selectedList.forEach((ele) => {
        idList.push(ele.id);
      });
      idList = idList.join();
      this.changeStatus({ id: idList }, status);
    },
    priceLevel() {
      this.$router.push("priceLevel");
    },
    // 上传商品分类
    goodsClass(file) {
      if (file && file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("fulFile", file[i]);
        }
        let judge = "";
        let type = "UploadClassificationExecl";
        this.$uploadRequest({
          url: "admin/ashx/UploadExcel.ashx?type=" + type + "&judge=" + judge,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "上传成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    /**点击新增/编辑 */
    handleAdd(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify({ goodsId: row.articleId,goods_no:row.goods_no }));
      } else {
        prams = "";
      }
      this.$router.push({
        path: "addProduct",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    /**清空表单信息 */
    clearForm() {
      this.$refs["goodForm"].resetFields();
      for (const key in this.goodForm) {
        this.goodForm[key] = null;
      }
      this.addDialog = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["goodForm"].validate((valid) => {
        if (valid) {
          this.$message({
            message: "执行提交",
            type: "info",
          });
        }
      });
    },
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定下架吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定上架吗?";
        type = "success";
      }
      this.$prompt(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(({ value }) => {
          let data = {
            articleId: row.id,
            status: status,
            remark: value,
          };
          this.$request({
            url: "/Management/GoodsAdmin/AutGoodsStatus",
            data: data,
            method: "post",
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
      // this.$confirm(msg, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: type,
      // })
      //   .then(() => {
      //     let data = {
      //       articleId: row.id,
      //       status: status,
      //     };
      //     this.$request({
      //       url: "/Management/GoodsAdmin/AutGoodsStatus",
      //       data: data,
      //       method: "post",
      //     })
      //       .then((res) => {
      //         if (res.success) {
      //           this.$message({
      //             message: "操作成功",
      //             type: "success",
      //           });
      //           this.getTableData();
      //         } else {
      //           this.$message({
      //             message: res.message,
      //             type: "error",
      //           });
      //         }
      //       })
      //       .catch((err) => {
      //         window.console.log(err);
      //       });
      //   })
      //   .catch(() => {});
    },
    // 控销
    controlGoods(row) {
      let prams =
        row && encodeURIComponent(JSON.stringify({ goodsId: row.articleId }));
      this.$router.push({
        path: "addConGoods",
        query: {
          prams: prams,
        },
      });
    },
    // 区域价格
    areaPrice(row) {
      let prams =
        row &&
        encodeURIComponent(
          JSON.stringify({ goodsId: row.articleId, entId: row.entid })
        );
      this.$router.push({
        path: "productAreaPrice",
        query: {
          prams: prams,
        },
      });
    },
    // 导出数据
    exportData() {
      let data = {
        type: "GoodsList",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        category: this.searchForm.classify || "0",
        attribute: this.searchForm.attr || "0",
        status: this.searchForm.status || "9",
        strWhere: this.searchForm.name,
        promtype:
          this.searchForm.activityArea == "99"
            ? ""
            : this.searchForm.activityArea,
        stock_quantity: this.searchForm.activityStatus,
        goodsPic: this.searchForm.pic || "99",
        spStatus: this.searchForm.stock || "99",
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_Admin_GoodsList";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=商品列表";
    },
  },
};
</script>

<style scoped>
.productList {
  width: 100%;
  height: 100%;
}

/**选择上传图片类型 */
.imgType {
  padding: 20px 0 30px;
}

.imgType-item {
  width: 200px;
  height: 100px;
  margin: 20px auto 0;
  /* background-color: #409EFF; */
}

.imgType-item:first-of-type {
  margin-top: 0;
}

.imgType-item-btn {
  width: 100%;
  height: 100%;
}
.label {
  font-size: 13px;
}
.labeljs {
  font-size: 13px;
  margin-left: 10px;
}
.scopeName {
  font-size: 14px;
}
.searchBarLefy {
  width: 100%;
}
.searchBar-Lefy {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.searchBar-Right {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>